import { plaidItemsRoutine, PLAID_CLEANUP } from '@/store/modules/plaid/routines'
import { logoutRoutine } from '@/store/modules/auth/routines'
import { getPlaidItems } from '@/api/plaid'
import requestFlow from '@/utils/requestFlow'
import { state as initialState } from './index'

export default {
  ...requestFlow(plaidItemsRoutine, getPlaidItems).actions,

  [logoutRoutine.SUCCESS](context) {
    context.commit(PLAID_CLEANUP, initialState)
  }
}
